import { render, unmountComponentAtNode } from 'react-dom'
import LiveModal from 'live/components/ui/Modal'
import React from 'react'
import { css } from 'emotion'

import DateService from 'live/services/date'

const modalCss = css`
    .modal-body {
        padding: 0;
        overflow-y: scroll;
        overflow-x: hidden;
        max-height: 400px;
        table {
            width: 100%;
        }
        tr.message-item {
            border-bottom: 1px solid #333;
            td {
                padding: 4px 8px;
            }
            td:first-child {
                white-space: nowrap;
                width: 10%;
            }
        }
        tr:nth-child(even) {
            background: #fff;
        }
    }
`

interface MessageGroup {
    messages: {
        timestamp: number
        value: string
    }[]
}

type SpanPickerType = 'time' | 'depth'

interface Props {
    toggle: () => void
    data: MessageGroup
    spanPickerType: SpanPickerType
}

export default function Messages({ toggle, data, spanPickerType }: Props): JSX.Element {
    return (
        <LiveModal className={modalCss} onHide={toggle} show={true}>
            <LiveModal.Header>
                <LiveModal.Title>Messages</LiveModal.Title>
            </LiveModal.Header>
            <LiveModal.Body>
                <table>
                    {data.messages.map((message, i) => (
                        <tr key={i} className={'message-item'}>
                            <td>
                                {spanPickerType === 'time'
                                    ? DateService.formatDateTime(message.timestamp)
                                    : message.timestamp}
                            </td>
                            <td>{message.value}</td>
                        </tr>
                    ))}
                </table>
            </LiveModal.Body>
            <LiveModal.Footer>
                <button className="btn btn-primary" onClick={toggle}>
                    Close
                </button>
            </LiveModal.Footer>
        </LiveModal>
    )
}

export const openModal = function(data: MessageGroup, spanPickerType: SpanPickerType): void {
    let modal = document.getElementById('__modal')
    if (!modal) {
        modal = document.createElement('div')
        modal.id = '__modal'
        document.body.appendChild(modal)
    }

    function toggle(): void {
        unmountComponentAtNode(modal)
    }

    render(<Messages toggle={toggle} spanPickerType={spanPickerType} data={data} />, modal)
}
